import { render, staticRenderFns } from "./AddUserForm.vue?vue&type=template&id=2357c847&scoped=true"
import script from "./AddUserForm.vue?vue&type=script&lang=js"
export * from "./AddUserForm.vue?vue&type=script&lang=js"
import style0 from "./AddUserForm.vue?vue&type=style&index=0&id=2357c847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357c847",
  null
  
)

export default component.exports